module.exports = __webpack_public_path__ + "static/media/cross16.055e6b26.svg";